import { render } from "./BasicAccessCodePaymentAudit.vue?vue&type=template&id=05bd10a4"
import script from "./BasicAccessCodePaymentAudit.vue?vue&type=script&lang=js"
export * from "./BasicAccessCodePaymentAudit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__